import DTO from './DTO';
import { required } from '../utils/validation';

class RepresentativeDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'representative_name',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.name',
      },
      {
        name: 'representative_id',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.name',
      },
      {
        name: 'inn',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.inn',
      },
      {
        name: 'organization_name',
        type: String,
        validators: [],
        labelKey: 'representative.organization_name',
      },
      {
        name: 'address',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'location_address',
      },
      {
        name: 'document_of_authority',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.document_of_authority',
      },
      {
        name: 'document_of_authority_number',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.document_of_authority_number',
      },
      {
        name: 'document_of_authority_issue_date',
        type: String,
        validators: [
          required,
        ],
        labelKey: 'representative.document_of_authority_issue_date',
      },
      {
        name: 'document_of_authority_expiration_date',
        type: String,
        validators: {},
        labelKey: 'representative.document_of_authority_expiration_date',
      },
      {
        name: 'representative_document_scan',
        type: String,
        validators: [required],
        labelKey: 'media.representative_document_scan',
      },
      {
        name: 'phone',
        type: String,
        validators: [required],
        labelKey: 'phone',
      },
      {
        name: 'email',
        type: String,
        validators: {},
        labelKey: 'pd.email',
      },
      {
        name: 'representative_identity_files',
        type: String,
        validators: [],
        labelKey: 'representative_identity_files',
        couldBeNull: true,
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default RepresentativeDTO;
